export default "__VITE_ASSET__wDH__FXZ__"